import { render, staticRenderFns } from "./zlw.vue?vue&type=template&id=1f3ac87c&scoped=true&"
var script = {}
import style0 from "./zlw.vue?vue&type=style&index=0&id=1f3ac87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ac87c",
  null
  
)

export default component.exports